import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import * as actions from './actions'
import Cookies from 'js-cookie'

// Styles
import './styles.scss'

// Components
import Footer from '../../components/Footer'
import Loading from '../../components/Loading'

// Icons
import ImageLeft from './images/imageLeft'
import ImageRight from './images/imageRight'
import ImageLeaf from './images/imageLeaf'

export default (): JSX.Element => {
  const [codeAuthorization, setCodeAuthorization] = useState<string>('')
  const [iframeLoaded, setIframeLoaded] = useState<boolean>(false)

  const isAuthed = !!Cookies.get('token')

  const {
    REACT_APP_SSO_DOMAIN,
    REACT_APP_SSO_CLIENT_ID,
    REACT_APP_SSO_REDIRECT_URI,
  } = process.env

  if (isAuthed) {
    return <Redirect to={'/'} />
  }

  const dispatch = useDispatch()

  const url = new URL(window.location.href)
  const came_from = url.searchParams.get('redirect_uri')
  const iframeInitialUrl = `https://${REACT_APP_SSO_DOMAIN}/oauth/authorize?client_id=${REACT_APP_SSO_CLIENT_ID}&redirect_uri=${REACT_APP_SSO_REDIRECT_URI}&response_type=code`

  const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === 'IFRAME'

  const getIframeUrl = (iframe: HTMLElement) => {
    const interval = setInterval(() => {
      if (isIFrame(iframe) && iframe.contentWindow) {
        try {
          const url = iframe.contentWindow.location?.href
          if (url && url !== 'about:blank') {
            clearInterval(interval)
            const parseURL = new URL(url)
            const code = parseURL.searchParams.get('code')
            if (code) {
              setCodeAuthorization(code)
            } else {
              alert('Что-то пошло не так, попробуйте снова')
              iframe.setAttribute('src', iframeInitialUrl)
            }
          }
          return url
        } catch (e) {
          return e
        }
      }
    }, 100)
  }

  useEffect(() => {
    const iframe = document.getElementById('iframe')
    if (isIFrame(iframe) && iframe.contentWindow) {
      getIframeUrl(iframe)
      let registered = false
      if (iframe && iframe.contentWindow && iframe.contentWindow.postMessage) {
        window.onmessage = function (event: MessageEvent) {
          if (typeof event.data === 'object') {
            if (event.data.type === 'registered') {
              registered = true
            }
            if (event.data.type === 'resize') {
              iframe.style.height = event.data.height + 'px'
            }
          }
        }
        const interval = setInterval(function () {
          if (registered) {
            clearInterval(interval)
            return
          }
          if (iframe.contentWindow) {
            iframe.contentWindow.postMessage('register', '*')
          }
        }, 100)
      }
    }
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (codeAuthorization) {
      dispatch(
        actions.signIn(codeAuthorization, REACT_APP_SSO_REDIRECT_URI, came_from)
      )
    }
  }, [codeAuthorization])

  return (
    <>
      <div className={'authorization'}>
        <div className={'authorization__left'}>
          <ImageLeft />
        </div>
        <div className={'authorization__background'}>
          <ImageLeaf />
        </div>
        <div className={'authorization__center'}>
          <div className={'authorization__center-form'}>
            <div className={'outer'}>
              {codeAuthorization || !iframeLoaded ? (
                <Loading color={'#1978B2'} />
              ) : null}
              <iframe
                id={'iframe'}
                frameBorder={0}
                style={
                  iframeLoaded && !codeAuthorization ? {} : { display: 'none' }
                }
                onLoad={() => setIframeLoaded(true)}
                src={iframeInitialUrl}
              />
            </div>
          </div>
        </div>
        <div className={'authorization__right'}>
          <ImageRight />
        </div>
      </div>
      <Footer />
    </>
  )
}
